<span
  class="authenticated-header-wrapper registration-in-progress-wrapper"
  *ngIf="!registrationFinished"
>
  <ul class="nav align-items-center header-link-nav-bar">
    <li *ngIf="completeButtonVisible">
      <button
        type="button"
        class="btn-link me-1 me-md-2"
        (click)="navigateToStep3OfRegistration()"
        ngbDropdownItem
      >
        Complete set-up >
      </button>
    </li>
  </ul>
</span>
<span class="authenticated-header-wrapper">
  <ul
    class="nav align-items-center header-link-nav-bar d-none d-md-flex column-gap-4"
  >
    <li class="nav-item">
      <a routerLink="/lost-and-found">Lost &amp; found</a>
    </li>
    <li class="nav-item">
      <a routerLink="/contact-us">Contact us</a>
    </li>
    <ng-container *appFeatureFlag="'isHeaderIdentiProfessionalsEnabled'">
      <li class="nav-item">
        <a routerLink="/identi-professionals">identi professionals</a>
      </li>
    </ng-container>
  </ul>
  <ng-container *appFeatureFlag="'isHeaderInformationDropDownEnabled'">
    <ul class="nav align-items-center header-icon-nav-toggle d-none d-md-flex">
      <li
        ngbDropdown
        display="dynamic"
        placement="bottom-right"
        class="nav-item ms-4"
        (openChange)="opened($event)"
      >
        <button ngbDropdownToggle class="nav-info nav-link">Information</button>
        <div ngbDropdownMenu class="px-3">
          <a ngbDropdownItem routerLink="/microchipping-your-pet">Microchipping</a>
          <a
            ngbDropdownItem
            href="https://identicare.zendesk.com/hc/en-us"
            target="_blank"
          >
            Help Centre
          </a>
          <a
            ngbDropdownItem
            href="https://identiblog.zendesk.com/hc/en-us"
            target="_blank"
          >
            Blog
          </a>
        </div>
      </li>
    </ul>
  </ng-container>
  <ul class="nav align-items-center header-link-nav-bar d-none d-md-flex">
    <div class="nav-item-divider d-none d-xl-block"></div>

    <li class="nav-item d-none d-xl-block">
      <a 
      routerLink="/dashboard"
      trackClickEvent
      [eventNumber]="ClickEventNumbersEnum.Dashboard" 
      class="fw-bold"
      >
        Dashboard
      </a>
    </li>
    <li class="nav-item mx-4 d-none d-xl-block">
      <a routerLink="/account">
        My account
      </a>
    </li>

    <li class="d-none d-xl-block">
      <button
        type="button"
        class="btn-link"
        (click)="authManager.logout()"
        ngbDropdownItem
      >
        Log out
      </button>
    </li>

    <div class="nav-item-divider"></div>

    <li class="nav-item nav-item-tok">
      <a
        routerLink="/claim-pet"
        class="fw-bold"
      >
        Transfer of Keepership
      </a>
    </li>

    <li class="d-none d-xl-block">
      <app-social-facebook
        [badgeWrapperSize]="'32px'"
        [badgeIconSize]="'20px'"
      ></app-social-facebook>
    </li>
    <li class="d-none d-xl-block">
      <app-social-instagram
        [badgeWrapperSize]="'32px'"
        [badgeIconSize]="'20px'"
      ></app-social-instagram>
    </li>
    <li class="d-none d-xl-block">
      <app-social-twitter
        [badgeWrapperSize]="'32px'"
        [badgeIconSize]="'20px'"
      ></app-social-twitter>
    </li>
  </ul>

  <ul
    class="nav align-items-center header-icon-nav-toggle d-block d-xl-none"
  >
    <li
      ngbDropdown
      display="dynamic"
      placement="bottom-right"
      class="nav-item"
      (openChange)="opened($event)"
    >
      <button ngbDropdownToggle class="nav-avatar nav-link">
        <span *ngIf="pets.length" class="nav-avatar-circle">
          <span
            class="nav-avatar-img"
            [ngStyle]="{
              'background-image': pets[0].imageId
                ? 'url(' + getPetImageUrl(pets[0].imageId) + ')'
                : 'none',
            }"
          >
            <span *ngIf="!pets[0].imageId" class="fw-bold">
              {{ pets[0].name.trim().charAt(0) | uppercase }}
            </span>
          </span>
        </span>
        <span *ngIf="!pets.length" class="nav-avatar-circle">
          <span class="nav-avatar-img">
            <fa-icon [icon]="['fas', 'user']" [fixedWidth]="true"></fa-icon>
          </span>
        </span>
      </button>
      <div ngbDropdownMenu class="px-3">
        <a ngbDropdownItem routerLink="/dashboard">Dashboard</a>
        <a ngbDropdownItem routerLink="/account">My account</a>
        <button
          type="button"
          class="btn-link"
          (click)="authManager.logout()"
          ngbDropdownItem
        >
          Log out
        </button>
        <a 
          ngbDropdownItem
          routerLink="/claim-pet"
          class="d-block d-md-none fw-bold"
        >
          Transfer of Keepership
        </a>

        <span class="d-block d-md-none">
          <a ngbDropdownItem routerLink="/microchipping-your-pet"
            >Microchipping</a
          >
          <a ngbDropdownItem routerLink="/lost-and-found">Lost &amp; found</a>
          <a ngbDropdownItem routerLink="/contact-us">Contact us</a>
          <a ngbDropdownItem *appFeatureFlag="'isHeaderIdentiProfessionalsEnabled'" routerLink="/identi-professionals">identi professionals</a>
          <a
            ngbDropdownItem
            *appFeatureFlag="'isHeaderInformationDropDownEnabled'"
            href="https://identicare.zendesk.com/hc/en-us"
            target="_blank">
            Help Centre
          </a>
          <a
            ngbDropdownItem
            *appFeatureFlag="'isHeaderInformationDropDownEnabled'"
            href="https://identiblog.zendesk.com/hc/en-us"
            target="_blank">
            Blog
          </a>
        </span>

        <span 
          *appFeatureFlag="'areSocialsAvailable'"
          class="social-icons-wrapper d-flex justify-content-center gap-2 mt-2 pt-1 border-top"
        >
          <app-social-facebook
            [badgeWrapperSize]="'24px'"
            [badgeIconSize]="'16px'"
          ></app-social-facebook>
          <app-social-instagram
            [badgeWrapperSize]="'24px'"
            [badgeIconSize]="'16px'"
          ></app-social-instagram>
          <app-social-twitter
            [badgeWrapperSize]="'24px'"
            [badgeIconSize]="'16px'"
          ></app-social-twitter>
        </span>
      </div>
    </li>
  </ul>
</span>
